import productSelectionIcon from "@surgia/ui/icons/catalog/selectProducts.svg";
import detailsConfigurationIcon from "@surgia/ui/icons/catalog/configureDetails.svg";
import customerViewIcon from "@surgia/ui/icons/catalog/customerView.svg";
 export const steps = [
    {
      id: 1,
      icon: productSelectionIcon,
      title: "admin.productAssignment.steps.selectProducts.title",
      subtitle: "admin.productAssignment.steps.selectProducts.subtitle",
      pageTitle:"admin.productAssignment.content.selectProducts.title"
    },
    {
    id: 2,
    icon: detailsConfigurationIcon,
    title: "admin.productAssignment.steps.configureDetails.title",
    subtitle: "admin.productAssignment.steps.configureDetails.subtitle",
    pageTitle: "admin.productAssignment.specifyVariantsTitle",
  },
  {
    id: 3,
      icon: customerViewIcon,
      title: "admin.productAssignment.steps.customerView.title",
      subtitle: "admin.productAssignment.steps.customerView.title",
      pageTitle: "admin.productAssignment.steps.customerView.title",
    },
  ];

export const filterInitialData={
  id: "",
  price_from: "",
  price_to: "",
  category: "",
  brand: "",
  brandName: "",
}